import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Dropdown, DropdownItem } from '@com-delta-omnichannel/mach-core-js';
import {
  CheckInTextData,
  CheckInWidget,
  CheckInWidgetFormType
} from '../models/check-in-widget.interfaces';
import { CheckInWidgetInitializationService } from './check-in-widget-initialization.service';

@Injectable({
  providedIn: 'root'
})
export class CheckInDropdownService {
  constructor(private initService: CheckInWidgetInitializationService) {}

  initializeDropdown(
    content: CheckInWidget,
    form: FormGroup<CheckInWidgetFormType>,
    onDropdownChange: (textData: CheckInTextData) => void
  ): Dropdown {
    const components = this.initService.initializeComponents(content);
    this.setupDropdownListeners(
      components.dropDownCheckInOptions,
      content,
      form,
      onDropdownChange
    );
    return components.dropDownCheckInOptions;
  }

  private setupDropdownListeners(
    dropdown: Dropdown,
    content: CheckInWidget,
    form: FormGroup<CheckInWidgetFormType>,
    onDropdownChange: (textData: CheckInTextData) => void
  ): void {
    const value = content?.inputSelectedDropdownOption[0]?.title;
    if (value) {
      dropdown.setValue(value);
      form.patchValue({ findTripBy: value });
    }

    dropdown.onChange((value: DropdownItem) => {
      const selectedOption = content.inputSelectedDropdownOption.find(
        (option) => option.title === value.value
      );
      if (selectedOption) {
        onDropdownChange(selectedOption);
        this.initService.updateVisibilityFlags(selectedOption.title);
        form.patchValue({ findTripBy: value.value });
      }
    });
  }
}
